module.exports = __webpack_public_path__ + "img/img-badge.910bc8c2.png";